import axios from "../plugins/parseAxios";

export class SchedulerTaskAPI {

  static createSchedulerTask(formData) {
    return axios.post("functions/createSchedulerTask", formData);
  }

  static updateSchedulerTask(formData) {
    return axios.post("functions/updateSchedulerTask", formData);
  }

  static getSchedulerTasksByContract(formData) {
    return axios.post("functions/getSchedulerTasksByContract", formData);
  }

  static getSchedulerTask(id) {
    return axios.post("functions/getSchedulerTask", { id });
  }

  static removeSchedulerTask(id) {
    return axios.post("functions/removeSchedulerTask", { id });
  }

  static activeSchedulerTask(formData) {
    return axios.post("functions/activeSchedulerTask", formData);
  }
}